module.exports = __webpack_public_path__ + "img/estudio.4a639f6c.jpg";